// Module
var code = "<footer class=\"tc-footer\">\n  Taslonic is a project carefully made\n  by <tc-link href=\"https://rafaelcamargo.com\">Rafael Camargo</tc-link>.\n</footer>\n";
// Exports
export default code;